<template>
  <div :class="[`key${name.toLowerCase()}`, classes, keyStateClass]" :title="title"></div>
</template>

<script>
import BaseKey from 'mixins/BaseKey';

export default {
  name: 'StandardKey',

  mixins: [BaseKey],

  computed: {
    isExpectedKey() {
      return this.character === this.expectedKey;
    },

    isToldHoldTypeTarget() {
      return this.isTouchHold && this.isExpectedKey && this.holdKeyPressed && this.showTargets;
    },

    isTargetedKey() {
      return !this.isTouchHold && this.isExpectedKey && this.showTargets;
    },

    isHomeRow() {
      return this.roofs;
    },

    classes() {
      return {
        ...this.baseClasses,
        homeRow: this.isHomeRow,
        oneHandedTyping: !!this.oneHandedTypingHand,
        target: this.isToldHoldTypeTarget || this.isTargetedKey
      };
    },

    title() {
      return `${this.name.toLowerCase()} key`;
    }
  }
};
</script>
